/* GR 10/10 (Lauren) - pre-order explainer.
   Hover a PRE-ORDER* badge (desktop) or tap it (phone) and a small white box with a black outline says
   the item is in high demand and ships in 3-5 weeks.  On stack cards the piece price carries a small
   "*PO" (drawn with CSS so the stack engine rewriting the price text on a size change cannot remove it)
   and the price itself is the trigger.

   Anything with [data-gr-po] is a trigger.  ONE tooltip element lives on <body> so it is never clipped
   by a card, slider or scroller with overflow:hidden.  Capture-phase click handling stops a tap on the
   badge from also following a card link or opening the stack piece viewer.

   Which products get a badge is decided ONLY by the product tag `preorder-badge` (in Liquid), never here. */
(function () {
  if (window.__grPoTip) return;
  window.__grPoTip = true;

  var TEXT = 'This product is in extremely high demand — expect 3–5 week delivery time. ' +
             'We will send the rest of your order within normal shipping times.';
  var THANKS = 'Thank you for your overwhelming love!';

  var css = '' +
    '[data-gr-po]{cursor:help;-webkit-tap-highlight-color:transparent;}' +
    '[data-gr-po]:focus{outline:none;}' +
    '[data-gr-po]:focus-visible{outline:1px solid #111;outline-offset:2px;}' +
    /* stack-card piece price: the small *PO beside the figure */
    '.gr-sbs__shoprow-price[data-gr-po]::after{content:"*PO";margin-left:4px;' +
      'font-size:1em;font-weight:inherit;letter-spacing:.02em;}' +   /* 10/10: same height as the price */
    '#gr-po-tip{position:fixed;z-index:2147483000;box-sizing:border-box;max-width:min(270px,calc(100vw - 24px));' +
      'background:#fff;color:#111;border:1px solid #111;padding:10px 12px;font-family:\"Helvetica Neue\",Helvetica,Arial,sans-serif;font-size:12px;' +
      'line-height:1.45;letter-spacing:.01em;text-align:left;text-transform:none;font-weight:400;white-space:normal;' +
      'pointer-events:auto;}' +
    '#gr-po-tip[hidden]{display:none!important;}' +
    '#gr-po-tip .gr-po-tip__thanks{display:block;margin-top:6px;font-weight:700;}';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var st = document.createElement('style');
    st.id = 'gr-po-tip-css';
    st.textContent = css;
    document.head.appendChild(st);

    var tip = document.createElement('div');
    tip.id = 'gr-po-tip';
    tip.setAttribute('role', 'tooltip');
    tip.hidden = true;
    tip.appendChild(document.createTextNode(TEXT));
    var thanks = document.createElement('span');
    thanks.className = 'gr-po-tip__thanks';
    thanks.textContent = THANKS;
    tip.appendChild(thanks);
    document.body.appendChild(tip);

    var current = null;      // the trigger the tip is showing for
    var hideTimer = null;

    function canHover() {
      return !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
    }
    function triggerOf(el) {
      return el && el.closest ? el.closest('[data-gr-po]') : null;
    }
    function place(t) {
      var r = t.getBoundingClientRect();
      tip.style.visibility = 'hidden';
      tip.hidden = false;
      var tw = tip.offsetWidth, th = tip.offsetHeight;
      var vw = document.documentElement.clientWidth, m = 12, gap = 8;
      var left = r.left + r.width / 2 - tw / 2;
      left = Math.max(m, Math.min(left, vw - tw - m));
      var top = r.top - th - gap;               // above the badge when there is room
      if (top < m) top = r.bottom + gap;        // otherwise below it
      tip.style.left = Math.round(left) + 'px';
      tip.style.top = Math.round(top) + 'px';
      tip.style.visibility = '';
    }
    function show(t) {
      clearTimeout(hideTimer);
      if (current && current !== t) current.removeAttribute('aria-describedby');
      current = t;
      t.setAttribute('aria-describedby', 'gr-po-tip');
      place(t);
    }
    function hide() {
      clearTimeout(hideTimer);
      if (current) current.removeAttribute('aria-describedby');
      current = null;
      tip.hidden = true;
    }
    function hideSoon() {
      clearTimeout(hideTimer);
      hideTimer = setTimeout(hide, 140);
    }

    /* desktop: hover in / out (the tip itself counts as "still hovering" so it can be read) */
    document.addEventListener('mouseover', function (e) {
      if (!canHover()) return;
      var t = triggerOf(e.target);
      if (t) { show(t); return; }
      if (current && (e.target === tip || tip.contains(e.target))) { clearTimeout(hideTimer); return; }
      if (current) hideSoon();
    });

    /* tap / click - capture phase so the card link or stack viewer never fires underneath */
    document.addEventListener('click', function (e) {
      var t = triggerOf(e.target);
      if (t) {
        e.preventDefault();
        e.stopPropagation();
        if (!canHover() && current === t && !tip.hidden) hide();
        else show(t);
        return;
      }
      if (current && !(e.target === tip || tip.contains(e.target))) hide();
    }, true);

    /* keyboard */
    document.addEventListener('focusin', function (e) {
      var t = triggerOf(e.target);
      if (t) show(t);
    });
    document.addEventListener('focusout', function (e) {
      if (triggerOf(e.target) && current) hideSoon();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && current) { hide(); return; }
      var t = triggerOf(e.target);
      if (t && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        if (current === t && !tip.hidden) hide(); else show(t);
      }
    });

    /* the tip is position:fixed, so anything that moves the page closes it */
    window.addEventListener('scroll', function () { if (current) hide(); }, true);
    window.addEventListener('resize', function () { if (current) hide(); });
  });
})();
